import {
  useSendEmailMutation,
  useSendTextMutation,
} from "@/store/conversations/apis";

export const useMessageSending = () => {
  const [sendEmail, { isLoading: isSendingEmail }] = useSendEmailMutation();
  const [sendText, { isLoading: isSendingText }] = useSendTextMutation();

  const handleSendEmail = async (
    customerId: number,
    subject: string,
    message: string,
    moveId?: number
  ) => {
    await sendEmail({
      customerId,
      subject,
      message,
      moveId,
    });
  };

  const handleSendText = async (
    customerId: number,
    message: string,
    moveId?: number
  ) => {
    await sendText({
      customerId,
      message,
      moveId,
    });
  };

  return {
    handleSendEmail,
    handleSendText,
    isSending: isSendingEmail || isSendingText,
  };
};
